"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PScriptContext = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var type_system_1 = require("../../../type_system/index.js");
var PScriptInfo_1 = require("./PScriptInfo/index.js");
var PTxInfo_1 = require("./PTxInfo/index.js");
exports.PScriptContext = (0, pstruct_1.pstruct)({
    PScriptContext: {
        tx: PTxInfo_1.PTxInfo.type,
        redeemer: type_system_1.data,
        purpose: PScriptInfo_1.PScriptInfo.type
    }
});
